import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useSelector, useDispatch } from 'react-redux';
import { all_routes } from "../../Router/all_routes";
import { set_Refund_Id } from "../../core/redux/action";
import { useNavigate } from "react-router-dom";
import { dateFormatter } from '../../plugins/helper';
// import Swal from 'sweetalert2';

const Refunds = () => {
    const route = all_routes;
    const dispatch = useDispatch();
    const navigate = useNavigate();

    // Initialize refundRequests as an empty array to hold refund request data
    const [refundRequests, setRefundRequests] = useState([]);
    const l = useSelector((state) => state.language || "en");
    const t = useSelector((state) => state.translation || {});   

    useEffect(() => {
        async function fetchData() {
            try {
                const result = await axios.get("getrefundrequest/");
                
                if(result?.data?.message)
                {
                  

                  setRefundRequests(result.data);
                }
                else
                {
                  const resunds = result.data.refundRequest.sort((a, b) => b.createdAt - a.createdAt);
                  setRefundRequests(resunds);
                }       
            } catch (error) {
                console.error('Error fetching refund requests:', error);
            }
        }
        fetchData();
    }, []); // Empty dependency array for running this only once after the initial render

    const handleShowDetails = (returnNumber) => {
        // Dispatch action to save returnNumber in Redux state
        dispatch(set_Refund_Id(returnNumber));

        // Navigate to the refund details page
        navigate(route.refunddetails);
    };

    return (
        <div className={`${l === 'ar' ? 'page-wrapper-rtl' : 'page-wrapper'}`}>
            <div className="content">
            <div className="page-header">
                    <div className="add-item d-flex">
                        <div className="page-title">
                            <h4>{t[l]?.["refund_requests"] || "Refund Requests"}</h4>
                            <h6>{t[l]?.["manage_your_returns"] || "Manage Your Returns"}</h6>
                        </div>
                    </div>
                    </div>
                    <div className="row">
                    {/* {refundRequests.message?(<></>)
                    :(
                        {refundRequests?.map((request, index) => (
                            <div className="col-md-6 mb-3" key={index}>
                                <div className="card">
                                    <div className="card-body">
                                        <p><strong>Order ID:</strong> {request.orderId}</p>
                                        <p><strong>Return Number:</strong> {request.returnNumber}</p>
                                        <p><strong>Generated on:</strong> {request.generatedDate}</p>
                                        <button
                                            onClick={() => handleShowDetails(request.returnNumber)}
                                            className="btn btn-primary"
                                        >
                                            Show Details
                                        </button>
                                    </div>
                                </div>
                            </div>
                        ))}
                      )} */}
                      {
  refundRequests?.message ? (
    <></> // This renders nothing if `refundRequests.message` is truthy
  ) : (
    refundRequests?.map((request, index) => (
      <div className="col-md-6 mb-3" key={index}>
        <div className="card">
          <div className="card-body">
            <p><strong>Order ID:</strong> {request?.orderId}</p>
            <p><strong>Return Number:</strong> {request?._id}</p>
            <p><strong>Generated on:</strong> {dateFormatter(request?.createdAt)}</p>
            <button
              onClick={() => handleShowDetails(request._id)}
              className="btn btn-primary"
            >
              Show Details
            </button>
          </div>
        </div>
      </div>
    ))
  )
}

                    </div>
                   
            </div>
        </div>
    );
};

export default Refunds;

// import React, { useState, useEffect } from 'react'
// import axios from 'axios';
// import { useSelector,useDispatch } from 'react-redux';
// import { all_routes } from "../../Router/all_routes";
// import { set_Refund_Id } from "../../core/redux/action";
// import { useNavigate } from "react-router-dom";
// const Refunds = () => {
//     const route = all_routes;
//     const dispatch = useDispatch();
//     const navigate = useNavigate();
//     const [refundRequests, setRefundRequests] = useState(new Date());
//     const l = useSelector((state) => state.language || "en");
//     // const t = useSelector((state) => state.translation || {});
//     useEffect(() => {
     
//       async function fetchData() {
//         let result = await axios.get("getrefundrequest/");
//         console.log('result getrefundrequest',result);
//         setRefundRequests(result.data);

//       }
//       fetchData()
//     }, [])

//   // Sample data as a state
//   // const refundRequests = [
//   //   {
//   //     orderId: "mTpnFzFNnA8TMrfDn",
//   //     returnNumber: "mTpnFzFNnA8TMrfDn",
//   //     generatedDate: "2024-08-07"
//   //   },
//   //   {
//   //     orderId: "mTpnFzFNnA8TMrfDn",
//   //     returnNumber: "mTpnFzFNnA8TMrfDn",
//   //     generatedDate: "2024-08-07"
//   //   },
//   //   {
//   //     orderId: "mTpnFzFNnA8TMrfDn",
//   //     returnNumber: "mTpnFzFNnA8TMrfDn",
//   //     generatedDate: "2024-08-07"
//   //   },
//   //   {
//   //     orderId: "mTpnFzFNnA8TMrfDn",
//   //     returnNumber: "mTpnFzFNnA8TMrfDn",
//   //     generatedDate: "2024-08-07"
//   //   }
//   // ];
//   const handleShowDetails = (returnNumber) => {
//     // Dispatch action to save returnNumber in Redux state
//     dispatch(set_Refund_Id(returnNumber));

//     // Navigate to the refund details page
//     navigate(route.refunddetails);
//   };

//   return (
//     <div className={`${l === 'ar' ? 'page-wrapper-rtl' : 'page-wrapper'}`}>
//                     <div className="content">
//     <div className="container">
//       <h2>Refund Requests</h2>
//       <p>Manage Your Returns</p>
//       <div className="row">
//         {refundRequests?.map((request, index) => (
//           <div className="col-md-6 mb-3" key={index}>
//             <div className="card">
//               <div className="card-body">
//                 <p><strong>Order ID:</strong> {request.orderId}</p>
//                 <p><strong>Return Number:</strong> {request.returnNumber}</p>
//                 <p><strong>Generated on:</strong> {request.generatedDate}</p>
//                 {/* <Link to={`${route.refunddetails}/${request.returnNumber}`} className="btn btn-primary">
//                   Show Details
//                 </Link> */}
//                 <button
//                       onClick={() => handleShowDetails(request.returnNumber)}
//                       className="btn btn-primary"
//                     >
//                       Show Details
//                     </button>
//               </div>
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//     </div>
//     </div>
//   );
// };

// export default Refunds;
